import '../css/stylesheet.css';
import '../fonts/fontsheet.css';
import Window from "../Window";
import flag from '../Flag_of_New_Holland.png';
import map from '../Map_of_New_Holland.png';

function CycloLink({ children }){
    return(
        <span style={{backgroundColor:"#EFEFEF", border: "1px solid black"}}>{ children }</span>
    )
}

function CycloBox({ children, width }){
    width = width ?? 300;
    return (
        <div style={{
            backgroundColor: "#FDFDFD",
            width,
            border: "1px solid black",
            padding: "0 0%", 
            margin: "0.2em 0.75em",
            float: "right"
        }}>
            { children }
        </div>
    )
}

function CycloArticle({ children, setWindows, title }){
    return (
        <Window windowName={title} setWindows={setWindows}>
            <div style={{
                margin: "0.2em",
                padding: "0.1em",
                border: "4px solid #000000",
                boxSizing: "border-box",
                backgroundColor: "#FFFFFF", height: "99%"
            }}>
                <div style={{
                    margin: "0.1em",
                    padding: "0.5em",
                    border: "1px solid #000000",
                    boxSizing: "border-box",
                    overflowY: "auto", height: "99%"
                }}>
                    { children }
                </div>
            </div>
        </Window>
    );
}

function CTPTOC(){
    function TOCEntry({ children, indent }){
        return (
            <p style={{backgroundColor:"#EFEFEF", border: "1px solid black", borderTop: "0px", padding: ("0 " + (1+(indent? indent: 0)) + "em"), margin: 0}}>
                { children }
            </p>
        );
    }

    return(
        <div style={{width: "350px"}}>
            <h6 style={{border: "1px solid black", borderLeft: "0px", padding: 0, margin: 0}}><CycloLink>▼</CycloLink> Table of Contents</h6>
            <TOCEntry>I. History</TOCEntry>
            <TOCEntry indent={1}>I.a. 1894-1919: Early French photonics</TOCEntry>
            <TOCEntry indent={1}>I.b 1919-1937: Foundation and early era</TOCEntry>
            <TOCEntry indent={1}>I.c. 1937-1977: Croatian War and aftermath</TOCEntry>
            <TOCEntry indent={1}>I.d. 1977-present: Crystal valve era and today</TOCEntry>
            <TOCEntry>II. Products</TOCEntry>
            <TOCEntry indent={1}>II.a. Crystal valves</TOCEntry>
            <TOCEntry indent={1}>II.b. Photes</TOCEntry>
            <TOCEntry indent={1}>II.c. Palvers</TOCEntry>
            <TOCEntry indent={2}>II.c.1. Dyna-Palver line</TOCEntry>
            <TOCEntry indent={1}>II.d. Photescopes</TOCEntry>
            <TOCEntry indent={1}>II.e. Analyzers</TOCEntry>
            <TOCEntry indent={2}>II.e.1. Silicule</TOCEntry>
            <TOCEntry indent={1}>II.f. Amusers</TOCEntry>
            <TOCEntry indent={1}>II.g. Handheld amusers</TOCEntry>
            <TOCEntry indent={1}>II.h. Other devices</TOCEntry>
            <TOCEntry>III. Marketing</TOCEntry>
            <TOCEntry>IV. Corporate affairs</TOCEntry>
            <TOCEntry indent={1}>IV.a. Leadership</TOCEntry>
            <TOCEntry indent={1}>IV.b. Controversies</TOCEntry>
            <TOCEntry>V. Criticisms</TOCEntry>
            <TOCEntry indent={1}>V.a. Anti-competition</TOCEntry>
            <TOCEntry indent={1}>V.b. Copyright enforcement</TOCEntry>
            <TOCEntry indent={1}>V.c. Patent violations</TOCEntry>
            <TOCEntry indent={1}>V.d. Litigation</TOCEntry>
            <TOCEntry indent={1}>V.e. Labor practices</TOCEntry>
            <TOCEntry indent={1}>V.f. Advertising</TOCEntry>
            <TOCEntry indent={1}>V.g. Tax avoidance</TOCEntry>
            <TOCEntry indent={1}>V.h. Privacy</TOCEntry>
            <TOCEntry>VI. Supply chains</TOCEntry>
            <TOCEntry>VII. Associations</TOCEntry>
            <TOCEntry>VIII. References</TOCEntry>
            <TOCEntry>IX. Further reading</TOCEntry>
        </div>
    );
}

function CTPArticle2({ setWindows }){
    return(
        <CycloArticle setWindows={setWindows} title="Réstéf - Encyclopaedia Universalis Mundaneum">
            <h1 style={{textAlign: "center"}}>Compagnie générale de la télégraphie photonique</h1>
            <CycloBox>
                <div style={{padding: "0 2%", backgroundColor: "#E0E0E0"}}>
                    <h6 style={{textAlign: "center"}}>Compagnie générale de la télégraphie photonique</h6>
                </div>
                <div style={{padding: 0, margin: 0}}>
                    <p style={{padding: "0 0", margin: "0 0", fontFamily: "Valencia", fontSize: "5em", textAlign: "center", color: "#555555"}}>CTP</p>
                    <p style={{textAlign: "center", marginTop: 0}}>Logo of the CTP (since 2015)</p>
                </div>
                <div style={{display: "grid", gridTemplateColumns: "33% 67%", padding: "0 2.5%", margin: "0.5em 0"}}>
                    <p style={{margin: "0 0.1em", fontWeight: "bold", fontFamily: "Charcoal"}}>Type</p>
                    <p style={{margin: "0 0.1em"}}><CycloLink>Public</CycloLink></p>
                </div>
                <div style={{display: "grid", gridTemplateColumns: "33% 67%", padding: "0 2.5%", margin: "0.5em 0"}}>
                    <p style={{margin: "0 0.1em", fontWeight: "bold", fontFamily: "Charcoal"}}>Traded on</p>
                    <div>
                        <p style={{margin: "0 0.1em"}}><CycloLink>Paris Bourse</CycloLink></p>
                        <p style={{margin: "0 0.1em"}}><CycloLink>Bon 100</CycloLink> component</p>
                        <p style={{margin: "0 0.1em"}}><CycloLink>Bon 500</CycloLink> component</p>
                        <p style={{margin: "0 0.1em"}}><CycloLink>Average Commerciel</CycloLink></p>
                    </div>
                </div>
                <div style={{display: "grid", gridTemplateColumns: "33% 67%", padding: "0 2.5%", margin: "0.5em 0"}}>
                    <p style={{margin: "0 0.1em", fontWeight: "bold", fontFamily: "Charcoal"}}><CycloLink>Securities ID</CycloLink></p>
                    <p style={{margin: "0 0.1em"}}><CycloLink>FR5239662629</CycloLink></p>
                </div>
                <div style={{display: "grid", gridTemplateColumns: "33% 67%", padding: "0 2.5%", margin: "0.5em 0"}}>
                    <p style={{margin: "0 0.1em", fontWeight: "bold", fontFamily: "Charcoal"}}>Industry</p>
                    <div>
                        <p style={{margin: "0 0.1em"}}><CycloLink>Crystal valve</CycloLink> production</p>
                        <p style={{margin: "0 0.1em"}}><CycloLink>Analyzer technology</CycloLink></p>
                    </div>
                </div>
                <div style={{display: "grid", gridTemplateColumns: "33% 67%", padding: "0 2.5%", margin: "0.5em 0"}}>
                    <p style={{margin: "0 0.1em", fontWeight: "bold", fontFamily: "Charcoal"}}>Founded</p>
                    <p style={{margin: "0 0.1em"}}>March 20, 1919 in <CycloLink>Paris, France</CycloLink></p>
                </div>
                <div style={{display: "grid", gridTemplateColumns: "33% 67%", padding: "0 2.5%", margin: "0.5em 0"}}>
                    <p style={{margin: "0 0.1em", fontWeight: "bold", fontFamily: "Charcoal"}}>Founders</p>
                    <div>
                        <p style={{margin: "0 0.1em"}}><CycloLink>Pierre Louis Hebert</CycloLink></p>
                        <p style={{margin: "0 0.1em"}}><CycloLink>Jean Brzezinski</CycloLink></p>
                        <p style={{margin: "0 0.1em"}}><CycloLink><em>and others....</em></CycloLink></p>
                    </div>
                </div>
                <div style={{display: "grid", gridTemplateColumns: "33% 67%", padding: "0 2.5%", margin: "0.5em 0"}}>
                    <p style={{margin: "0 0.1em", fontWeight: "bold", fontFamily: "Charcoal"}}>Headquarters</p>
                    <p style={{margin: "0 0.1em"}}><CycloLink>CTP headquarters</CycloLink>, Paris, France</p>
                </div>
                <div style={{display: "grid", gridTemplateColumns: "33% 67%", padding: "0 2.5%", margin: "0.5em 0"}}>
                    <p style={{margin: "0 0.1em", fontWeight: "bold", fontFamily: "Charcoal"}}>Areas served</p>
                    <p style={{margin: "0 0.1em"}}>Worldwide</p>
                </div>
                <div style={{display: "grid", gridTemplateColumns: "33% 67%", padding: "0 2.5%", margin: "0.5em 0"}}>
                    <p style={{margin: "0 0.1em", fontWeight: "bold", fontFamily: "Charcoal"}}>Key people</p>
                    <div>
                        <p style={{margin: "0 0.1em"}}><CycloLink>Jean-Baptiste Kurov</CycloLink> (<CycloLink>Director</CycloLink>)</p>
                        <p style={{margin: "0 0.1em"}}><CycloLink>Natalie Martin</CycloLink> (<CycloLink>Lt. Director</CycloLink>)</p>
                    </div>
                </div>
                <div style={{display: "grid", gridTemplateColumns: "33% 67%", padding: "0 2.5%", margin: "0.5em 0"}}>
                    <p style={{margin: "0 0.1em", fontWeight: "bold", fontFamily: "Charcoal"}}>Products</p>
                    <div>
                        <p style={{margin: "0 0.1em"}}><CycloLink>Crystal valves</CycloLink></p>
                        <p style={{margin: "0 0.1em"}}><CycloLink>Photes</CycloLink></p>
                        <p style={{margin: "0 0.1em"}}><CycloLink>Telepalvers</CycloLink></p>
                        <p style={{margin: "0 0.1em"}}><CycloLink>Photescopes</CycloLink></p>
                        <p style={{margin: "0 0.1em"}}><CycloLink>Analyzers</CycloLink></p>
                        <p style={{margin: "0 0.1em"}}><CycloLink>Amusers</CycloLink></p>
                        <p style={{margin: "0 0.1em"}}><CycloLink>Programme development</CycloLink></p>
                        <p style={{margin: "0 0.1em"}}><CycloLink>Restef</CycloLink></p>
                    </div>
                </div>
                <div style={{display: "grid", gridTemplateColumns: "33% 67%", padding: "0 2.5%", margin: "0.5em 0"}}>
                    <p style={{margin: "0 0.1em", fontWeight: "bold", fontFamily: "Charcoal"}}>Revenue</p>
                    <p style={{margin: "0 0.1em"}}>▲ <CycloLink>Fr.</CycloLink> 352.7 billion (2023)</p>
                </div>
                <div style={{display: "grid", gridTemplateColumns: "33% 67%", padding: "0 2.5%", margin: "0.5em 0"}}>
                    <p style={{margin: "0 0.1em", fontWeight: "bold", fontFamily: "Charcoal"}}>Réstéf address</p>
                    <p style={{margin: "0 0.1em"}}><CycloLink>FR::PAR:CTP</CycloLink>↗</p>
                </div>
            </CycloBox>
            <p>
                <strong>Compagnie generale de la telegraphie photonique</strong> (English: <em>General Company of Photonic Telegraphy</em>), 
                better known by its acronym <strong>CTP</strong>, is a <CycloLink>French</CycloLink> technology 
                corporation with head offices in <CycloLink>Paris, France</CycloLink>, but with many of its 
                operations headquartered in in <CycloLink>Aix-la-Chappelle, France</CycloLink>. It is today a 
                leading company in the manufacture of <CycloLink>photes</CycloLink>, <CycloLink>photescopes</CycloLink>,
                as well as <CycloLink>analyzers</CycloLink>, and more generally the <CycloLink>solid-state</CycloLink> industry. 
                Its flagship products include the <CycloLink>Chene</CycloLink> line of photescopes, 
                the <CycloLink>Silicule</CycloLink> line of <CycloLink>home analyzers</CycloLink>, 
                and the <CycloLink>Drole-Scope</CycloLink> series of amusers. The CTP is listed as #12  
                in the <CycloLink>Bon 100</CycloLink> on the <CycloLink>Paris Bourse</CycloLink> by total 
                revenue, and it is considered one of the world's leading tech companies.
            </p>
            <CTPTOC/>
            <h1>History</h1>
            <h2>1894-1919: Early French photonics</h2>
            <p>
                The <CycloLink>photonic revolution</CycloLink> began with the Marseillaise 
                inventor <CycloLink>Frederic Antoine Lombardi</CycloLink>, who like many at the time 
                attempted to discover means for <CycloLink>wireless telegraphy</CycloLink>. 
                Experimenting with <CycloLink>harmonic telegraphy</CycloLink>, Lombardi found in 1894 that 
                a <CycloLink>spark gap</CycloLink> produced another spark in a nearby relay, in effect 
                allowing for transmission of messages. Initially thinking this spark was generated by some 
                special form of <CycloLink>electrodynamic induction</CycloLink> at a distance, further 
                experiments led him to instead believe it was generated some form 
                of <CycloLink>aether wave</CycloLink> akin to light or exodal waves as held by the 
                then-common joint aether theory. Publishing his findings in 1897, Lombardi instead found 
                widespread mockery by the scientific community for what they widely regarded as the 
                musings of a crackpot; but not to be deterred, Lombardi performed further experiments to 
                obtain convincing proof of his hypothesis.
            </p>
            <p>
                Over the next few years, Lombardi analyzed this "aether wave" generated by his spark gap, 
                and he found that it could be reflected and refracted identically to <CycloLink>light</CycloLink>; 
                he further attempted to deflect it with a magnet as could be done 
                with <CycloLink>exodal waves</CycloLink> and found he could not, but he found he could 
                polarize it like light. Additionally, measuring its speed, he found it to be  within a margin of 
                error to light, and this led him to the conclusion that this was simply a 
                hitherto-undiscovered form of light; further analysis led him to realize it differed from 
                visible light in that it had a far longer <CycloLink>wavelength</CycloLink>. Publishing 
                his findings, Lombardi found a scientific community receptive to this line of reasoning, 
                for the German physicist <CycloLink>Karl Anton Schrader</CycloLink> had recently theorized 
                as a corollary of the <CycloLink>Ampere-Schrader Law</CycloLink> that light was a product 
                of <CycloLink>oscillating electric and magnetic waves</CycloLink>, and these findings 
                clearly generated such waves electrically. Thus, this both confirmed that Lombardi was no 
                crackpot and that Schrader's formulation of the electrodynamic wave was correct, making 
                the former a household name and gave the latter the first taste of his fame.
            </p>
            <p>
                With a potentially revolutionary patent for photonic telegraphy in hand, Lombardi worked 
                on commercializing his new invention. By 1902, Lombardi successfully extended the range of 
                his photonic telegraph to 500 metres, marketing it to ships to middling success; however, 
                he reached a hard limit in the next few years at two and a half kilometres, which many, 
                most infamously <CycloLink>J.P.H Miller</CycloLink>, claimed to be the fundamental limit set. 
                In 1907, his competitor <CycloLink>Jean-Baptiste Kowalski</CycloLink> successfully went 
                beyond this by raising the antenna and grounding both the transmitter and receiver, and 
                successfully marketed this improved photonic telegraph far more than Lombardi ever did. 
                Faced with a bottom line going down, Lombardi decided to sell his invention to the French 
                government. In short succession, in 1912, it gave itself a monopoly on photonic 
                telegraphy, effectively destroying Kowalski's business. For the next few years, in contrast 
                to other countries, photonics supplemented existing telegraph-based businesses.
            </p>
            <h2>1919-1937: Foundation and early era</h2>
            <p>In 1919, a group of French investors formed a company to operate photonic lines across the 
                Atlantic, naming it the CTP. They established transmittors and receivers between Nantes and 
                Quebec, and in quick succession they established the first commercial photonic lines to 
                Lagos and to Louanda, to Alexandria and then to Clangue and further to Zamboanga, Tamsoui, 
                and Lorient. These ambitious projects were highly successful and allowed for the CTP to 
                undercut the expensive submarine telegraph lines.
            </p>
            <p>
                Achieving commercial success through these lines, upon getting a license for the relevant 
                patents, they went on to create <CycloLink>crystal detector photes</CycloLink> for consumer 
                consumption in the 1920s. Though they competed not only with other companies but also with 
                homemade crystal photes, their quality and mass production meant they quickly dominate the 
                French market. They then sought to expand beyond this France, and over the 1920s, they 
                were able to sell crystal photes not only in the rest of <CycloLink>Europe</CycloLink> but 
                also in the rest of the <CycloLink>Americas</CycloLink>, 
                particularly <CycloLink>Francophone</CycloLink> <CycloLink>Laurentia</CycloLink>. 
            </p>
            <p>
                In the 1930s, faced with the revolutionary new technology of the <CycloLink>thermexodal valve</CycloLink> which 
                were capable of making photes which could broadcast sound without the need for headphones, 
                the CTP was faced with losing market share. It took a period of investing in in thermex 
                factories in the <CycloLink>Flanders-Roer metropolitan region</CycloLink> for them to 
                regain their position, but in its wake they manufactured many thermex photes; additionally, 
                they found that the same thermex valves were very useful for the new technology of 
                the <CycloLink>telepalver</CycloLink>. All of these endeavours made the CTP a very 
                prosperous company in the golden age of photonics.
            </p>
            <h2>1937-1977: Croatian War and aftermath</h2>
            <p>
                During the <CycloLink>Croatian War (1937-41)</CycloLink>, this production escalated with 
                the demand for military photes, and so did the thermex valve industry, and it suddenly 
                outpaced the crystal detector as the dominant form of the phote. Postwar, over the 1940s, 
                thermex technology suddenly became cheap for the consumer, and so did thermex photes. 
                With the Flanders-Roer region bombed out, a lot of new, modernized factories popped up, 
                which had the special effect of moving the centre of the CTP's gravity eastward, and 
                numerous company functions were totally transferred to new offices in Aix-la-Chappelle.
            </p>
            <p>
                The postwar rationalizations of French <CycloLink>palver lines</CycloLink>, which for the first 
                time merged them together into a single national network, was one which greatly benefited the CTP,
                as it increased demands in the thermex valve industry which the CTP now dominated. The 1940s 
                subsequently saw the proliferation of palvers across France, and it also successfully expanded 
                to the <CycloLink>Italian</CycloLink> and <CycloLink>Croatian</CycloLink> markets in this era. 
            </p>
            <p>
                In the 1960s, the boom for miniaturized <CycloLink>acorn valves</CycloLink> benefitted 
                the CTP further, as the <CycloLink>thermex analyzer</CycloLink>, 
                once commercially-unviable for their gigantic energy consumption and valve fragility, 
                were now viable and greatly weakened the stature of the century-old invention of 
                the <CycloLink>hydraulic analyzer</CycloLink>. This, and the acquisition of 
                the <CycloLink>Compagnie de machines a tabuler</CycloLink> in 1972, gave it a huge 
                and unprecedented marketshare in the analyzer industry. 
            </p>
            <p>
                This period also saw the rise of commercially available photescopes. The CTP had previously 
                developed a <CycloLink>mechanical photescope</CycloLink> which used a spinning drum to 
                display images, the <CycloLink>CTP Scopecule</CycloLink> in 1954, and its high price and 
                noisy spinning drum made it commercially unviable. As a result, it wrote off the entire
                photescope industry, and as a result it was slow to bring new scopes to the market. 
                in 1968, it invested in a new prototype, the <CycloLink>Chene</CycloLink>, with 
                an <CycloLink>EWT screen</CycloLink>. In its wake, the CTP invested in EWT screen 
                factories and brought the Chene to market in 1970. All of these led the CTP to maintain 
                its commercial dominance in the photonics space and indeed even expand this further to the 
                new markets developing thanks to the process of <CycloLink>decolonization</CycloLink>.
            </p>
            <h2>1977-present: Crystal valve era and today</h2>
            <p>
                The next great commercial revolution came with the invention of the <CycloLink>crystal valve</CycloLink>. 
                In an instant, this made the thermex valve obsolete and allowed for the creation of 
                circuits that, with their <CycloLink>solid state</CycloLink>, both used less energy and 
                produced less heat, allowing them to be spaced together. Though the CTP largely ignored it 
                upon <CycloLink>its invention in 1971</CycloLink> due to its use of 
                commercially-unfriendly <CycloLink>humboldtium</CycloLink>, the commercial success of 
                solid-state photes, as well as the invention of the cheaper and more 
                durable <CycloLink>silicon valve</CycloLink> in 1977, it invested heavily in the new 
                industry, and it was a leading player in the transformation of Aix-la-Chappelle 
                into <CycloLink>Silicon City</CycloLink>, developing the factories from which this name came 
                into existence. The CTP also became a leading producer of <CycloLink>block circuits</CycloLink>, 
                including for the <CycloLink>French space program</CycloLink>.
            </p>
            <p>
                The rapid proliferation of analyzers, especially <CycloLink>numeric analyzers,</CycloLink> into 
                the workplace this inspired in the 1970s and 80s was a move which CTP led in no small part. It 
                commissioned analyzers for these purposes, most famously the <CycloLink>CTP Mini</CycloLink> in 
                1984, which was small enough to fit in a cabinet and as such was a leading element of 
                the <CycloLink>analyzer revolution</CycloLink>. Though many spoke of this as 
                a <CycloLink>home analyzer</CycloLink>, this analyzer's size, small store, and unfriendly 
                user interface, made this possibility to act as such minimal. But nevertheless, the CTP 
                gained a larger share of the workplace analyzer market. 
            </p>
            <p>
                In the 1980s, the CTP worked on <CycloLink>packet networks</CycloLink>. This was a 
                technology then in its infancy and largely used by various governments in the era 
                of <CycloLink>koric panic</CycloLink>, and this for the first time allowed for the rise 
                of <CycloLink>analyzer time-sharing</CycloLink> over the same decade. These series of 
                network are widely considered the first formulation of the commercial <CycloLink>Restef</CycloLink> network.
            </p>
            <p>
                In 1994, the CTP released its first <CycloLink>appliance analyzer</CycloLink> for the use 
                of <CycloLink>home analyzing</CycloLink>, the <CycloLink>CTP Silicule I</CycloLink>. However, 
                attempts to market this failed due to its high price tag of French Fr. 45,000 (approximately 
                US$230,000 today). As a result, aside from use in a few large French corporations, this 
                product failed. Further attempts to reduce cost resulted in the <CycloLink>CTP Silicule II</CycloLink> in 
                1996 and, to widespread success, the <CycloLink>CTP Silicule III</CycloLink> in 1998. 
            </p>
            <p>
                The Silicule III was among the first best-selling appliance analyzers, and its uptake began today's 
                era of increasingly-commplace analyzing. The Silicule III came packaged with 
                the <CycloLink>Electro-Fiche</CycloLink>, a gram development and data management programme 
                first made for the <CycloLink>Mundaneum</CycloLink> to numerize its 
                famously-large <CycloLink>index card</CycloLink> collection with all its complicated associations, 
                and this was one of the most popular programmes and saw widespread uptake. In 2000, 
                the <CycloLink>Helvetian</CycloLink> programmer <CycloLink>Flurin Wirth</CycloLink> developed a 
                transfer protocol for transmitting Electro-Fiche grams over the Restef on <CycloLink>telepalver lines</CycloLink>, 
                the <CycloLink>Tell protocol</CycloLink>. This swiftly saw uptake and quickly became the chief 
                Restef protocol, linking together analyzers across Europe, helping to secure Restef's 
                position as the leading <CycloLink>packet network</CycloLink> in Europe. 
            </p>
            <p>
                In this era, the CTP also put a foot into the <CycloLink>amuser</CycloLink> industry. The lowering 
                price of analyzing technology had, over the 1990s and early 2000s, allowed for a massive boom in 
                the <CycloLink>home amuser</CycloLink> industry, and this resulted in a massive amount of 
                speculation and blind investment. The <CycloLink>burst of this bubble in 2005</CycloLink> both 
                left a sparse home amuser market, and destroyed many of the CTP's competitors. In 2007, the CTP 
                sought to enter this space with the release of the <CycloLink>Drole-Scope</CycloLink>, which 
                contained a rigorous licensing program for new games intended to prevent the glut of low-quality 
                games that many regarded as responsible for the 2005 crash. This successfully achieved for the CTP 
                the acquisition of a massive amount of the European amuser market share. More recently, in 2021, 
                the CTP released the handheld <CycloLink>Virgule-Scope</CycloLink>, albeit to middling success 
                due to competition. 
            </p>
            <p>
                The CTP has also entered into the <CycloLink>pocket palver</CycloLink> market. In 2019, at 
                the <CycloLink>Zanzibar City World Expo</CycloLink>, it unveiled a prototype, which while not the 
                first pocket palver was not quite the brick that was the norm at the time than others. It entered 
                the market under the name <CycloLink>Dyna-Palver</CycloLink> in 2021, although despite initial 
                success, it found itself hemmed by other competitors. 
            </p>
        </CycloArticle>
    )
}

function CTPArticle3({ setWindows }){
    return(
        <CycloArticle setWindows={setWindows} title="New Holland">
            <CycloBox width={325}>
                <div style={{padding: "0 2%", backgroundColor: "#5E5E5E"}}>
                    <h6 style={{color:"#FFFFFF"}}>▼&nbsp;&nbsp;New Holland</h6>
                </div>
                <div style={{padding: 0, margin: 0}}>
                    <p style={{textAlign: "center", marginTop: 10, paddingLeft: 5, paddingRight: 5}}>
                        <strong><em>Republique de Nouvelle-Hollande</em> (<CycloLink>French</CycloLink>)</strong>
                    </p>
                    <p style={{textAlign: "center", marginTop: 0}}>
                        <strong> Republic of New Holland (<CycloLink>English</CycloLink>)</strong>
                    </p>
                    <p style={{textAlign: "center", marginTop: 0}}>
                        <img src={flag} alt="New Holland" width="250"></img>
                    </p>
                </div>
                <div style={{display: "grid", gridTemplateColumns: "40% 60%", padding: "0 2.5%", margin: "0.5em 0"}}>
                    <p style={{margin: "0 0.1em", fontWeight: "bold", fontFamily: "Charcoal"}}>&nbsp;Capital</p>
                    <p style={{margin: "0 0.1em"}}><CycloLink>Lorient</CycloLink></p>
                </div>
                <div style={{display: "grid", gridTemplateColumns: "40% 60%", padding: "0 2.5%", margin: "0.5em 0"}}>
                    <p style={{margin: "0 0.1em", fontWeight: "bold", fontFamily: "Charcoal"}}>&nbsp;Continent</p>
                    <p style={{margin: "0 0.1em"}}><CycloLink>Oceania</CycloLink></p>
                </div>
                <div style={{display: "grid", gridTemplateColumns: "40% 60%", padding: "0 2.5%", margin: "0.5em 0"}}>
                    <p style={{margin: "0 0.1em", fontWeight: "bold", fontFamily: "Charcoal"}}>&nbsp;Borders</p>
                    <p style={{margin: "0 0.1em"}}><CycloLink>Commonwealth of Australia</CycloLink></p>
                </div>
                <CycloBox width={"92%"}>
                    <div style={{padding: "0 2%", backgroundColor: "#5E5E5E"}}>
                        <h6 style={{color:"#FFFFFF"}}>▼&nbsp;&nbsp;Administration</h6>
                    </div>
                    <div style={{display: "grid", gridTemplateColumns: "40% 60%", padding: "0 2.5%", margin: "0.5em 0"}}>
                        <p style={{margin: "0 0.1em", fontWeight: "bold", fontFamily: "Charcoal"}}><CycloLink>Grand Elector</CycloLink></p>
                        <p style={{margin: "0 0.1em"}}>&nbsp;<CycloLink>John Maloney</CycloLink></p>
                    </div>
                    <div style={{display: "grid", gridTemplateColumns: "40% 60%", padding: "0 2.5%", margin: "0.5em 0"}}>
                        <p style={{margin: "0 0.1em", fontWeight: "bold", fontFamily: "Charcoal"}}><CycloLink>General Council of the Interior</CycloLink></p>
                        <p style={{margin: "0 0.1em"}}>&nbsp;<CycloLink>Amelie Tam</CycloLink></p>
                    </div>
                    <div style={{display: "grid", gridTemplateColumns: "40% 60%", padding: "0 2.5%", margin: "0.5em 0"}}>
                        <p style={{margin: "0 0.1em", fontWeight: "bold", fontFamily: "Charcoal"}}><CycloLink>Legislature</CycloLink></p>
                        <p style={{margin: "0 0.1em"}}>&nbsp;<CycloLink>National Assembly</CycloLink></p>
                    </div>
                    <div style={{display: "grid", gridTemplateColumns: "40% 60%", padding: "0 2.5%", margin: "0.5em 0"}}>
                        <p style={{margin: "0 0.1em", fontWeight: "bold", fontFamily: "Charcoal"}}><CycloLink>President of the National Assembly</CycloLink></p>
                        <p style={{margin: "0 0.1em"}}>&nbsp;<CycloLink>Guillaume Bremer</CycloLink></p>
                    </div>
                    <div style={{display: "grid", gridTemplateColumns: "40% 60%", padding: "0 2.5%", margin: "0.5em 0"}}>
                        <p style={{margin: "0 0.1em", fontWeight: "bold", fontFamily: "Charcoal"}}><CycloLink>Judiciary</CycloLink></p>
                        <p style={{margin: "0 0.1em"}}>&nbsp;<CycloLink>Tribunal of Cassation</CycloLink></p>
                    </div>
                    <div style={{display: "grid", gridTemplateColumns: "40% 60%", padding: "0 2.5%", margin: "0.5em 0"}}>
                        <p style={{margin: "0 0.1em", fontWeight: "bold", fontFamily: "Charcoal"}}><CycloLink>President of the Tribunal of Cassation</CycloLink></p>
                        <p style={{margin: "0 0.1em"}}>&nbsp;<CycloLink>Lawrence Haig</CycloLink></p>
                    </div>
                    <div style={{display: "grid", gridTemplateColumns: "40% 60%", padding: "0 2.5%", margin: "0.5em 0"}}>
                        <p style={{margin: "0 0.1em", fontWeight: "bold", fontFamily: "Charcoal"}}><CycloLink>Form of government</CycloLink></p>
                        <p style={{margin: "0 0.1em", paddingLeft:"10px"}}><CycloLink>Unitary</CycloLink> <CycloLink>republic</CycloLink> under a <CycloLink>democratic</CycloLink> <CycloLink>ministerial</CycloLink> <CycloLink>directorial</CycloLink> <CycloLink>constitution</CycloLink></p>
                    </div>
                    <div style={{display: "grid", gridTemplateColumns: "40% 60%", padding: "0 2.5%", margin: "0.5em 0"}}>
                        <p style={{margin: "0 0.1em", fontWeight: "bold", fontFamily: "Charcoal"}}><CycloLink>Form of law</CycloLink></p>
                        <p style={{margin: "0 0.1em"}}>&nbsp;<CycloLink>Cambaceres Code</CycloLink></p>
                    </div>
                </CycloBox>
                <CycloBox width={"92%"}>
                    <div style={{padding: "0 2%", backgroundColor: "#5E5E5E"}}>
                        <h6 style={{color:"#FFFFFF"}}>▼&nbsp;&nbsp;Geography</h6>
                    </div>
                    <div style={{display: "grid", gridTemplateColumns: "40% 60%", padding: "0 2.5%", margin: "0.5em 0"}}>
                        <p style={{margin: "0 0.1em", fontWeight: "bold", fontFamily: "Charcoal"}}>Area</p>
                        <p style={{margin: "0 0.1em"}}>&nbsp;2,534,596 km<sup>2</sup></p>
                    </div>
                    <div style={{display: "grid", gridTemplateColumns: "40% 60%", padding: "0 2.5%", margin: "0.5em 0"}}>
                        <p style={{margin: "0 0.1em", fontWeight: "bold", fontFamily: "Charcoal"}}>Largest cities</p>
                        <p style={{margin: "0 0.1em"}}>
                            &nbsp;<CycloLink>Lorient</CycloLink><br/>
                            &nbsp;<CycloLink>Esperance</CycloLink><br/>
                            &nbsp;<CycloLink>Callaghanville</CycloLink><br/>
                        </p>
                    </div>
                    <div style={{display: "grid", gridTemplateColumns: "40% 60%", padding: "0 2.5%", margin: "0.5em 0"}}>
                        <p style={{margin: "0 0.1em", fontWeight: "bold", fontFamily: "Charcoal"}}><CycloLink>Time zone</CycloLink></p>
                        <p style={{margin: "0 0.1em"}}>&nbsp;TMP+08:00</p>
                    </div>
                    <div style={{display: "grid", gridTemplateColumns: "40% 60%", padding: "0 2.5%", margin: "0.5em 0"}}>
                        <p style={{margin: "0 0.1em", fontWeight: "bold", fontFamily: "Charcoal"}}><CycloLink>Currency</CycloLink></p>
                        <p style={{margin: "0 0.1em", paddingLeft:"10px"}}><CycloLink>New Hollandaise piastre</CycloLink></p>
                    </div>
                </CycloBox>
                <CycloBox width={"92%"}>
                    <div style={{padding: "0 2%", backgroundColor: "#5E5E5E"}}>
                        <h6 style={{color:"#FFFFFF"}}>▼&nbsp;&nbsp;Demography</h6>
                    </div>
                    <div style={{display: "grid", gridTemplateColumns: "40% 60%", padding: "0 2.5%", margin: "0.5em 0"}}>
                        <p style={{margin: "0 0.1em", fontWeight: "bold", fontFamily: "Charcoal"}}>Languages</p>
                        <p style={{margin: "0 0.1em"}}>
                            &nbsp;<CycloLink>French</CycloLink><br/>
                            &nbsp;<CycloLink>English</CycloLink><br/>
                        </p>
                    </div>
                    <div style={{display: "grid", gridTemplateColumns: "40% 60%", padding: "0 2.5%", margin: "0.5em 0"}}>
                        <p style={{margin: "0 0.1em", fontWeight: "bold", fontFamily: "Charcoal"}}>Population</p>
                        <p style={{margin: "0 0.1em"}}>&nbsp;3,813,000</p>
                    </div>
                    <div style={{display: "grid", gridTemplateColumns: "40% 60%", padding: "0 2.5%", margin: "0.5em 0"}}>
                        <p style={{margin: "0 0.1em", fontWeight: "bold", fontFamily: "Charcoal"}}>Density</p>
                        <p style={{margin: "0 0.1em"}}>&nbsp;1.50/km<sup>2</sup></p>
                    </div>
                </CycloBox>
                <CycloBox width={"92%"}>
                    <div style={{padding: "0 2%", backgroundColor: "#5E5E5E"}}>
                        <h6 style={{color:"#FFFFFF"}}>▼&nbsp;&nbsp;History</h6>
                    </div>
                    <div style={{display: "grid", gridTemplateColumns: "40% 60%", padding: "0 2.5%", margin: "0.5em 0"}}>
                        <p style={{margin: "0 0.1em", fontWeight: "bold", fontFamily: "Charcoal"}}><CycloLink>French Colony of New Holland</CycloLink></p>
                        <p style={{margin: "0 0.1em"}}>&nbsp;April 7, 1808</p>
                    </div>
                    <div style={{display: "grid", gridTemplateColumns: "40% 60%", padding: "0 2.5%", margin: "0.5em 0"}}>
                        <p style={{margin: "0 0.1em", fontWeight: "bold", fontFamily: "Charcoal"}}><CycloLink>Charter of Self-Government</CycloLink></p>
                        <p style={{margin: "0 0.1em"}}>&nbsp;April 7, 1808</p>
                    </div>
                    <div style={{display: "grid", gridTemplateColumns: "40% 60%", padding: "0 2.5%", margin: "0.5em 0"}}>
                        <p style={{margin: "0 0.1em", fontWeight: "bold", fontFamily: "Charcoal"}}><CycloLink>Declaration of Independence</CycloLink></p>
                        <p style={{margin: "0 0.1em"}}>&nbsp;January 22, 1954</p>
                    </div>
                </CycloBox>
                <CycloBox width={"92%"}>
                    <div style={{padding: "0 2%", backgroundColor: "#5E5E5E"}}>
                        <h6 style={{color:"#FFFFFF"}}>▼&nbsp;&nbsp;Symbols</h6>
                    </div>
                    <div style={{display: "grid", gridTemplateColumns: "40% 60%", padding: "0 2.5%", margin: "0.5em 0"}}>
                        <p style={{margin: "0 0.1em", fontWeight: "bold", fontFamily: "Charcoal"}}><CycloLink>National festival</CycloLink></p>
                        <p style={{margin: "0 0.1em", paddingLeft:"10px"}}>
                            <CycloLink>Naturaliste Day</CycloLink><br/>
                            Commemorating the <CycloLink>Battle of Cape Naturaliste</CycloLink> (1883)
                        </p>
                    </div>
                    <div style={{display: "grid", gridTemplateColumns: "40% 60%", padding: "0 2.5%", margin: "0.5em 0"}}>
                        <p style={{margin: "0 0.1em", fontWeight: "bold", fontFamily: "Charcoal"}}><CycloLink>Anthem</CycloLink></p>
                        <p style={{margin: "0 0.1em"}}>&nbsp;<em><CycloLink>L'Armee des Nations</CycloLink></em><br/>&nbsp;<CycloLink>Army of the Nations</CycloLink></p>
                    </div>
                    <div style={{display: "grid", gridTemplateColumns: "40% 60%", padding: "0 2.5%", margin: "0.5em 0"}}>
                        <p style={{margin: "0 0.1em", fontWeight: "bold", fontFamily: "Charcoal"}}><CycloLink>Motto</CycloLink></p>
                        <p style={{margin: "0 0.1em"}}>&nbsp;<em>Unite, Liberte, Ordre</em></p>
                    </div>
                </CycloBox>
                <CycloBox width={"92%"}>
                    <div style={{padding: "0 2%", backgroundColor: "#5E5E5E"}}>
                        <h6 style={{color:"#FFFFFF"}}>▼&nbsp;&nbsp;Map</h6>
                    </div>
                    <div style={{padding: 0, margin: 0}}>
                        <p style={{textAlign: "center"}}>
                            <img style={{border: "1px solid #5E5E5E"}} src={map} alt="New Holland" width="250"></img>
                        </p>
                    </div>
                </CycloBox>
            </CycloBox>
        </CycloArticle>
    )
}

function CTPArticle({ setWindows }){
    return(
        <CycloArticle setWindows={setWindows} title="Feargus O'Connor">
            <CycloBox width={325}>
                <div style={{padding: "0 2%", backgroundColor: "#5E5E5E"}}>
                    <h6 style={{color:"#FFFFFF"}}>▼&nbsp;&nbsp;Feargus O'Connor</h6>
                </div>
                <CycloBox width={"92%"}>
                    <div style={{padding: "0 2%", backgroundColor: "#5E5E5E"}}>
                        <h6 style={{color:"#FFFFFF"}}>▼&nbsp;&nbsp;Picture</h6>
                    </div>
                    <div style={{textAlign: "center", marginTop: "3px"}}>
                        <img src="//upload.wikimedia.org/wikipedia/commons/thumb/4/49/Feargus_Edward_O%27Connor-crop.jpg/220px-Feargus_Edward_O%27Connor-crop.jpg" decoding="async" width="220" height="260" class="mw-file-element" srcset="//upload.wikimedia.org/wikipedia/commons/thumb/4/49/Feargus_Edward_O%27Connor-crop.jpg/330px-Feargus_Edward_O%27Connor-crop.jpg 1.5x, //upload.wikimedia.org/wikipedia/commons/thumb/4/49/Feargus_Edward_O%27Connor-crop.jpg/440px-Feargus_Edward_O%27Connor-crop.jpg 2x" data-file-width="1406" data-file-height="1663"/>
                        <p>Engraving from the <CycloLink>Parliamentary <br/> Gazette</CycloLink>, 1835</p>
                    </div>
                </CycloBox>
                <CycloBox width={"92%"}>
                    <div style={{padding: "0 2%", backgroundColor: "#5E5E5E"}}>
                        <h6 style={{color:"#FFFFFF"}}>▼&nbsp;&nbsp;Political Offices</h6>
                    </div>
                    <div style={{margin: "0 2%", padding: "0 2%", backgroundColor: "#CFCFCF", textAlign: "center"}}>
                        <p style={{fontFamily: "Charcoal"}}>Councillor of State (France)</p>
                    </div>
                    <div style={{margin: "0 2%", padding: "0 2%"}}>
                        <p style={{fontSize: "0.6em"}}><CycloLink>National Notable</CycloLink> for <CycloLink>Loiret department</CycloLink></p>
                        <p style={{textAlign: "center"}}>June 12, 1824 - January 30, 1827</p>
                    </div>
                    <div style={{display: "grid", gridTemplateColumns: "20% 80%", padding: "0 2.5%", margin: "0.5em 0"}}>
                        <p style={{margin: "0 0.1em", fontWeight: "bold", fontFamily: "Charcoal"}}><CycloLink>Consul</CycloLink></p>
                        <p style={{margin: "0 0.1em"}}>&nbsp;<CycloLink>Bernard-Francois de Chauvelin</CycloLink></p>
                    </div>

                    <div style={{margin: "0 2%", padding: "0 2%", backgroundColor: "#CFCFCF", textAlign: "center"}}>
                        <p style={{fontFamily: "Charcoal"}}>Tribune (France)</p>
                    </div>
                    <div style={{margin: "0 2%", padding: "0 2%"}}>
                        <p style={{fontSize: "0.6em"}}><CycloLink>National Notable</CycloLink> for <CycloLink>Loiret department</CycloLink></p>
                        <p style={{textAlign: "center"}}>June 11, 1859 - June 10, 1865</p>
                    </div>
                    <div style={{display: "grid", gridTemplateColumns: "30% 70%", padding: "0 2.5%", margin: "0.5em 0"}}>
                        <p style={{margin: "0 0.1em", fontWeight: "bold", fontFamily: "Charcoal"}}><CycloLink>First Tribune</CycloLink></p>
                        <p style={{margin: "0 0.1em"}}>&nbsp;<CycloLink>Jules Favre</CycloLink></p>
                    </div>
                    <div style={{margin: "0 2%", padding: "0 2%"}}>
                        <p style={{textAlign: "center"}}>June 11, 1822 - June 12, 1824</p>
                    </div>
                    <div style={{display: "grid", gridTemplateColumns: "30% 70%", padding: "0 2.5%", margin: "0.5em 0"}}>
                        <p style={{margin: "0 0.1em", fontWeight: "bold", fontFamily: "Charcoal"}}><CycloLink>First Tribune</CycloLink></p>
                        <p style={{margin: "0 0.1em"}}>&nbsp;<CycloLink>Benjamin Constant</CycloLink></p>
                    </div>

                    <div style={{margin: "0 2%", padding: "0 2%", backgroundColor: "#CFCFCF", textAlign: "center"}}>
                        <p style={{fontFamily: "Charcoal"}}>Member of Parliament (British Isles)</p>
                    </div>
                    <div style={{margin: "0 2%", padding: "0 2%"}}>
                        <p style={{fontSize: "0.6em"}}>For the <CycloLink>1st Grand Division of Cork City</CycloLink></p>
                        <p style={{textAlign: "center"}}>March 15, 1843 - May 6, 1847</p>
                    </div>
                    <div style={{display: "grid", gridTemplateColumns: "40% 60%", padding: "0 2.5%", margin: "0.5em 0"}}>
                        <p style={{margin: "0 0.1em", fontWeight: "bold", fontFamily: "Charcoal"}}>Preceded by</p>
                        <p style={{margin: "0 0.1em"}}>&nbsp;<CycloLink>Alexander McCarthy</CycloLink></p>
                    </div>
                    <div style={{display: "grid", gridTemplateColumns: "40% 60%", padding: "0 2.5%", margin: "0.5em 0"}}>
                        <p style={{margin: "0 0.1em", fontWeight: "bold", fontFamily: "Charcoal"}}>Succeeded by</p>
                        <p style={{margin: "0 0.1em"}}>&nbsp;<CycloLink>William Fagan</CycloLink></p>
                    </div>
                    <div style={{margin: "0 2%", padding: "0 2%"}}>
                        <p style={{fontSize: "0.6em"}}>For the <CycloLink>2nd Grand Division of King's County</CycloLink></p>
                        <p style={{textAlign: "center"}}>March 15, 1829 - March 15, 1836</p>
                    </div>
                    <div style={{display: "grid", gridTemplateColumns: "40% 60%", padding: "0 2.5%", margin: "0.5em 0"}}>
                        <p style={{margin: "0 0.1em", fontWeight: "bold", fontFamily: "Charcoal"}}>Preceded by</p>
                        <p style={{margin: "0 0.1em"}}>&nbsp;<CycloLink>John Clere Parsons</CycloLink> <br/>&nbsp;<span style={{fontSize: "0.6em"}}>(<CycloLink>Convention Parliament</CycloLink>)</span></p>
                    </div>
                    <div style={{display: "grid", gridTemplateColumns: "40% 60%", padding: "0 2.5%", margin: "0.5em 0"}}>
                        <p style={{margin: "0 0.1em", fontWeight: "bold", fontFamily: "Charcoal"}}>Succeeded by</p>
                        <p style={{margin: "0 0.1em"}}>&nbsp;<CycloLink>Nicholas Fitzsimon</CycloLink></p>
                    </div>
                    
                    
                    <div style={{margin: "0 2%", padding: "0 2%", backgroundColor: "#CFCFCF", textAlign: "center"}}>
                        <p style={{fontFamily: "Charcoal"}}>Member of the Irish Legislative Assembly</p>
                    </div>
                    <div style={{margin: "0 2%", padding: "0 2%"}}>
                        <p style={{fontSize: "0.6em"}}>For the <CycloLink>1st Grand Division of Cork City</CycloLink></p>
                        <p style={{textAlign: "center"}}>May 6, 1847 - May 6, 1856</p>
                    </div>
                    <div style={{display: "grid", gridTemplateColumns: "40% 60%", padding: "0 2.5%", margin: "0.5em 0"}}>
                        <p style={{margin: "0 0.1em", fontWeight: "bold", fontFamily: "Charcoal"}}>Preceded by</p>
                        <p style={{margin: "0 0.1em"}}>&nbsp;None&nbsp;<span style={{fontSize: "0.6em"}}>(Assembly established)</span></p>
                    </div>
                    <div style={{display: "grid", gridTemplateColumns: "40% 60%", padding: "0 2.5%", margin: "0.5em 0"}}>
                        <p style={{margin: "0 0.1em", fontWeight: "bold", fontFamily: "Charcoal"}}>Succeeded by</p>
                        <p style={{margin: "0 0.1em"}}>&nbsp;<CycloLink>Francis Beamish</CycloLink></p>
                    </div>
                </CycloBox>
                <CycloBox width={"92%"}>
                    <div style={{padding: "0 2%", backgroundColor: "#5E5E5E"}}>
                        <h6 style={{color:"#FFFFFF"}}>▼&nbsp;&nbsp;Personal details</h6>
                    </div>
                    <div style={{display: "grid", gridTemplateColumns: "40% 60%", padding: "0 2.5%", margin: "0.5em 0"}}>
                        <p style={{margin: "0 0.1em", fontWeight: "bold", fontFamily: "Charcoal"}}>Born</p>
                        <p style={{margin: "0 0.1em"}}>&nbsp;18 July, 1796<br/>&nbsp;near <CycloLink>Kinneigh</CycloLink>, <br/>&nbsp;<CycloLink>Ireland</CycloLink>, <CycloLink>British Isles</CycloLink></p>
                    </div>
                    <div style={{display: "grid", gridTemplateColumns: "40% 60%", padding: "0 2.5%", margin: "0.5em 0"}}>
                        <p style={{margin: "0 0.1em", fontWeight: "bold", fontFamily: "Charcoal"}}>Died</p>
                        <p style={{margin: "0 0.1em"}}>&nbsp;16 November, 1868 <br/>&nbsp;(aged 72)<br/>&nbsp;<CycloLink>Paris</CycloLink>,&nbsp;<CycloLink>French Republic</CycloLink></p>
                    </div>
                    <div style={{display: "grid", gridTemplateColumns: "40% 60%", padding: "0 2.5%", margin: "0.5em 0"}}>
                        <p style={{margin: "0 0.1em", fontWeight: "bold", fontFamily: "Charcoal"}}>Nationality</p>
                        <p style={{margin: "0 0.1em"}}>&nbsp;<CycloLink>British</CycloLink> (natural-born)<br/>&nbsp;<CycloLink>French</CycloLink> (naturalized)</p>
                    </div>
                    <div style={{display: "grid", gridTemplateColumns: "40% 60%", padding: "0 2.5%", margin: "0.5em 0"}}>
                        <p style={{margin: "0 0.1em", fontWeight: "bold", fontFamily: "Charcoal"}}>Political Party</p>
                        <p style={{margin: "0 0.1em"}}>&nbsp;<CycloLink>Coppetard</CycloLink><br/>&nbsp;<CycloLink>Advanced Radical</CycloLink><br/>&nbsp;<CycloLink>Young Ireland</CycloLink><br/>&nbsp;<CycloLink>New Republican Union</CycloLink></p>
                    </div>
                    <div style={{display: "grid", gridTemplateColumns: "40% 60%", padding: "0 2.5%", margin: "0.5em 0"}}>
                        <p style={{margin: "0 0.1em", fontWeight: "bold", fontFamily: "Charcoal"}}>Spouse(s)</p>
                        <p style={{margin: "0 0.1em"}}>&nbsp;Celine Mickiewicz <br/>&nbsp;<span style={{fontSize: "0.6em"}}>(m. 1821; w. 1868)</span></p>
                    </div>
                    <div style={{display: "grid", gridTemplateColumns: "40% 60%", padding: "0 2.5%", margin: "0.5em 0"}}>
                        <p style={{margin: "0 0.1em", fontWeight: "bold", fontFamily: "Charcoal"}}>Child(ren)</p>
                        <p style={{margin: "0 0.1em"}}>&nbsp;Brien, <CycloLink>Lazare</CycloLink>, Fiona</p>
                    </div>
                    <div style={{display: "grid", gridTemplateColumns: "40% 60%", padding: "0 2.5%", margin: "0.5em 0"}}>
                        <p style={{margin: "0 0.1em", fontWeight: "bold", fontFamily: "Charcoal"}}>Relations</p>
                        <p style={{margin: "0 0.1em"}}>&nbsp;<CycloLink>Arthur O'Connor</CycloLink> <br/>&nbsp;(uncle)</p>
                    </div>
                </CycloBox>
            </CycloBox>
        </CycloArticle>
    )
}

export { CTPArticle };